module.exports = __webpack_public_path__ + "img/DS40_6x8v2.7cca8af0.png";